/**
 * Build an authenticated URL for uploaded files served at /api/uploads.
 */
export const getUploadUrl = (filePath) => {
  if (!filePath) {
    return null;
  }

  if (filePath.startsWith('http')) {
    return filePath;
  }

  let apiPath = filePath;
  if (apiPath.startsWith('/uploads/')) {
    apiPath = `/api${apiPath}`;
  } else if (!apiPath.startsWith('/api/uploads/')) {
    apiPath = `/api/uploads/${apiPath.replace(/^\//, '')}`;
  }

  const baseUrl = process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

  const token = localStorage.getItem('token');
  const url = `${baseUrl}${apiPath}`;

  if (!token) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${encodeURIComponent(token)}`;
};

export default getUploadUrl;
